/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Spaces_Column_OwnerInputs */



/**
* | output |
* | --- |
* | "Ownership" |
*
* @param {Member_Spaces_Column_OwnerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_spaces_column_owner = /** @type {((inputs?: Member_Spaces_Column_OwnerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Spaces_Column_OwnerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Besitz")
	return /** @type {LocalizedString} */ ("Ownership")
});